import * as React from 'react';
import { NodeType } from '../../../enums/NodeType';
import { useActions } from '../metadataFormActions';
import { useSelector } from '../../../utils/useSelector';
import { ShowFieldsOption } from '../../../enums/ShowFieldsOption';
import { getItemStatusId, getShowFieldsOption } from '../../../utils';
import { Dropdown } from '../../Dropdown/dropdown';
import { AppRefId } from '../../../utils/constants';
import { Eye, DownArrow } from '../../Icon/icon';
import './showFields.scss';
import { ItemStatus } from '../../../enums/ItemStatus';

const OptionToLabel: Record<ShowFieldsOption, string> = {
  [ShowFieldsOption.Default]: 'Default Fields',
  [ShowFieldsOption.RequiredForPhase]: 'Required Fields for Workflow Phase',
  [ShowFieldsOption.RequiredToPromote]: 'Required to Promote',
  [ShowFieldsOption.All]: 'All Fields'
} as const;

const PlanningItemOptions = [
  ShowFieldsOption.RequiredForPhase,
  ShowFieldsOption.RequiredToPromote
];

export const ShowFields = () => {
  const data = useSelector(s => s.form?.data);
  const schema = useSelector(s => s.form?.schema);
  const userSettings = useSelector(s => s.planning?.userSettings);
  const { setShowFieldsOption } = useActions();

  if (!userSettings) return null;
  if (schema?.props?.type != NodeType.Item) return null;

  const isPlanningItem = !data?.props?.itemId;
  const itemStatusId = getItemStatusId(data);
  const isItemCreated =
    !isPlanningItem || itemStatusId === ItemStatus.PendingCPPItemCreation;

  const showFieldsOption = getShowFieldsOption(data, userSettings);

  const options = [
    ShowFieldsOption.Default,
    ...(isItemCreated ? [] : PlanningItemOptions),
    ShowFieldsOption.All
  ];

  return (
    <Dropdown
      className="show-fields"
      options={options}
      selected={showFieldsOption}
      renderOption={o => OptionToLabel[o]}
      onSelect={o => setShowFieldsOption(o)}
      position="right"
    >
      <Eye />
      <span className="show-fields-trigger">Show fields</span>{' '}
      <DownArrow className="show-fields-arrow" />
    </Dropdown>
  );
};
